import { gql } from '@apollo/client';
const ADD_TENANT_SIZING = gql `
  mutation AddTenantSizing($tenantId: ID!, $name: String!, $sizeNames: [String]!) {
    addModelSpecificationSizeStandard(tenantId: $tenantId, name: $name, sizeNames: $sizeNames) {
      modelSpecificationSizeStandard {
        id
        name
        isActive
        isDefault
        sizes {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export default ADD_TENANT_SIZING;
